module.exports = __webpack_public_path__ + "static/media/ios-notifications-outline.535670f6.svg";